import { TFunction } from 'react-i18next';

import cloneDeep from 'lodash/cloneDeep';

import { getCateringTitleTranslationKey } from 'data/mapping/MealType';

import { HotelListResponse } from 'proto/Api/Hotel/HotelList';
import { Hotel } from 'proto/Hotel/Hotel';
import { MealType, mealTypeFromJSON } from 'proto/Offer/MealType';

interface HotelMapped extends Hotel {
    mealTitle?: string;
    roomTitle?: string;
    combinedMealRoomTitle?: string;
}

export const mapAccommodationListResponseForLegacy = (
    t: TFunction,
    accommodationResponse: HotelListResponse
) => {
    const accommodationResponseForMap = cloneDeep(accommodationResponse);
    if (accommodationResponseForMap?.hotelList?.items) {
        const items = accommodationResponseForMap?.hotelList?.items;
        //let k: keyof typeof items;
        for (const k in items) {
            const hotel: HotelMapped = items[k]; // O
            const mealType = hotel?.offer?.accommodationData?.mealType;
            const roomDescription =
                hotel?.offer?.accommodationData?.roomDescription;
            const mealTypeString = mealTypeFromJSON(
                mealType ?? MealType.MealTypeUnknown
            );
            const mealTitle = t(getCateringTitleTranslationKey(mealTypeString));
            const roomCount = hotel?.offer?.travelAttributes?.roomCount ?? 1;
            const roomTitle = t('TRANS-room-type[i]', {
                postProcess: 'interval',
                count: roomCount,
                roomType: roomDescription?.name || t('TRANS-room'),
            });
            const combinedMealRoomTitle = [];
            if (mealTitle) {
                hotel.mealTitle = mealTitle;
                combinedMealRoomTitle.push(mealTitle);
            }
            if (roomTitle) {
                hotel.roomTitle = roomTitle;
                combinedMealRoomTitle.push(roomTitle);
            }
            if (combinedMealRoomTitle.length > 0) {
                hotel.combinedMealRoomTitle = combinedMealRoomTitle.join(', ');
            }
        }
    }

    return accommodationResponseForMap;
};
